import {Component, OnInit} from '@angular/core';
import {LoginInfoComponent} from '../../user/login-info/login-info.component';
import { AuthApiService } from 'app/core/api/auth-api.service';
import { config } from 'app/shared/smartadmin.config';


@Component({

  selector: 'sa-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {

  isAdmin = false;
  isTorre = false;
  isRefacciones = false;
  isGerencia = false;
  isDireccion = false;
  isFacturacion = false;
  isCuentasxPagar = false;
  isSubDireccion = false;

  constructor(
    private authService: AuthApiService
  ) {
  }

  ngOnInit() {

    this.isAdmin = this.authService.GetRolEnabled(config.roles.admin);
    this.isTorre = this.authService.GetRolEnabled(config.roles.torre);
    this.isRefacciones = this.authService.GetRolEnabled(config.roles.refacciones);
    this.isDireccion  = this.authService.GetRolEnabled(config.roles.direccion);
    this.isGerencia =  this.authService.GetRolEnabled(config.roles.gerencia);
    this.isFacturacion = this.authService.GetRolEnabled(config.roles.facturacion);
    this.isCuentasxPagar = this.authService.GetRolEnabled(config.roles.cuentasxpagar);
    this.isSubDireccion = this.authService.GetRolEnabled(config.roles.subDireccion);

  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/navigation/navigation.component.ts